import { render, staticRenderFns } from "./layout-section.vue?vue&type=template&id=2f4d1734&"
import script from "./layout-section.vue?vue&type=script&lang=js&"
export * from "./layout-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports